<template>
    <div>
        <ModuleHeader :moduleName="text.notLoggedIn"/>
        <div class="content-container">
            <p class="explication-text">{{ text.explicationText }}</p>
            <br>
            <br>
            <div class="buttons">
                <BMButton route="/login">{{ text.toLoginPage }}</BMButton>
            </div>
            <!-- <LangSelector/> -->
        </div>
    </div>
</template>

<script>
import ModuleHeader from '@/components/ModuleHeader'
import BMButton from '@/components/BlackMoonUI/BMButton'
import LangSelector from '@/components/LangSelector'

export default {
    components: {
        ModuleHeader,
        BMButton,
        LangSelector
    },
    computed: {
        text(){
            return this.$texts[this.$i18n.locale].notLoggedIn
        }
    }
}
</script>

<style lang="scss" scoped>
    .explication-text {
        text-align: center;
        padding: 4vw;
        font-size: 12px;
    }

    .buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
</style>